import { Avatar, Col, Row } from 'antd';
import IconComponent from 'components/common/IconComponent';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';
import { RoleEnum } from 'types/user';
import { getDefaultAvatarUrl, numberFormatter } from 'utils';

import { IInvoiceSummaryProps } from './types';

// userData is notary data
const ClientInfoSummary: React.FC<IInvoiceSummaryProps> = ({ className, companyData }) => {
  const history = useHistory();

  const { name, avatar, appointmentCount, total, balance } = useMemo(() => {
    if (companyData) {
      return {
        name: companyData.name,
        avatar: companyData.avatar?.thumbnailPipeFrom || getDefaultAvatarUrl(companyData.name?.[0]),
        appointmentCount: companyData.appointmentCount,
        total: companyData.total,
        balance: companyData.balance,
      };
    }
    return {};
  }, [companyData]);

  // const [manuallyGenInvoice] = useMutation(generateInvoice);
  // const onGenerateInvoiceClick = async () => {
  //   try {
  //     await manuallyGenInvoice();
  //     defaultNotification({ success: 'Generate invoices successfully!' });
  //     if (isFunction(refetchInvoice)) refetchInvoice?.();
  //   } catch (err) {
  //     console.log('Error', err);
  //     defaultNotification({ failure: 'Generate invoices failed! Please try again.' });
  //   }
  // };
  return (
    <div className={`${className || ''} user-summary gx-d-flex`}>
      <div className='user-info-container'>
        <IconComponent
          onClick={() => {
            history.push({ pathname: ROUTES.ACCOUNTINGS, state: RoleEnum.CLIENT });
          }}
          name='arrow-left'
          className='gx-mr-3'
        />
        <div className='gx-d-flex gx-align-items-center user-info'>
          <Avatar src={avatar} className='gx-mr-2' size='large' />
          <div style={{ flex: '1', fontSize: 18 }} className='gx-font-weight-medium'>
            {name}
          </div>
        </div>
      </div>
      <div className='invoice-summary'>
        <Row className='invoice-data'>
          <Col span={8}>{appointmentCount || 0}</Col>
          <Col span={8}>${numberFormatter(total || 0)}</Col>
          <Col className='invoice-balance' span={8}>
            ${numberFormatter(balance || 0)}
          </Col>
        </Row>
        <Row className='invoice-title'>
          <Col span={8}>Appointments</Col>
          <Col span={8}>Total</Col>
          <Col span={8}>Unpaid Balance</Col>
        </Row>
      </div>
      {/* <div className='invoice-generator'>
        <ButtonWithSpinner width='auto' buttonType='primary' onClick={onGenerateInvoiceClick}>
          Generate Invoices
        </ButtonWithSpinner>
      </div> */}
    </div>
  );
};

export default React.memo(ClientInfoSummary);
